import React, { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import api from '@/lib/api';

/**
 * Viser en banner øverst når backend gir 5xx eller nettverksfeil.
 * Forsvinner automatisk når forespørsler går igjennom igjen.
 * Monteres én gang globalt i App.js.
 */
export default function ServerStatusBanner() {
  const [down, setDown] = useState(false);

  useEffect(() => {
    let failCount = 0;
    let checkTimer = null;

    // Interceptor som teller 5xx / nettverksfeil
    const id = api.interceptors.response.use(
      (res) => {
        if (down) setDown(false);
        failCount = 0;
        return res;
      },
      (err) => {
        const status = err?.response?.status;
        const isDown = !err.response || (status >= 500 && status < 600);
        if (isDown) {
          failCount += 1;
          if (failCount >= 2 && !down) setDown(true);
        } else {
          failCount = 0;
        }
        return Promise.reject(err);
      }
    );

    return () => {
      api.interceptors.response.eject(id);
      if (checkTimer) clearInterval(checkTimer);
    };
  }, [down]);

  // Polle helse-endepunkt når nede for å oppdage at server er oppe igjen
  useEffect(() => {
    if (!down) return;
    const t = setInterval(async () => {
      try {
        await api.get('/');
        setDown(false);
      } catch { /* fortsatt nede */ }
    }, 5000);
    return () => clearInterval(t);
  }, [down]);

  if (!down) return null;

  return (
    <div
      data-testid="server-status-banner"
      className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-2 text-sm text-center shadow-md flex items-center justify-center gap-2"
    >
      <RefreshCw size={14} className="animate-spin" />
      Oppdaterer … serveren er midlertidig nede. Vent 1–2 min, du forblir innlogget.
    </div>
  );
}
